import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { VersionCheckService } from '../../core/services/version-check.service';

const SNOOZE_MS = 30 * 60 * 1000;

@Component({
	selector: 'app-version-update-banner',
	templateUrl: './version-update-banner.component.html',
	styleUrls: ['./version-update-banner.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class VersionUpdateBannerComponent implements OnInit, OnDestroy {
	public visible = false;

	private newVersionAvailable = false;

	private dismissedAt: number = null;

	private sub: Subscription;

	constructor(private vcs: VersionCheckService) { }

	ngOnInit() {
		this.sub = this.vcs.newVersionAvailable$.subscribe((available) => {
			this.newVersionAvailable = available;
			this.updateVisibility();
		});

		document.addEventListener('visibilitychange', this.onVisibilityChange);
	}

	ngOnDestroy() {
		this.sub.unsubscribe();
		document.removeEventListener('visibilitychange', this.onVisibilityChange);
	}

	dismiss() {
		this.dismissedAt = Date.now();
		this.updateVisibility();
	}

	reload() {
		window.location.reload();
	}

	private onVisibilityChange = () => this.checkSnooze();

	private checkSnooze() {
		if (document.visibilityState !== 'visible') {
			return;
		}

		if (this.dismissedAt && Date.now() - this.dismissedAt > SNOOZE_MS) {
			this.dismissedAt = null;
		}

		this.updateVisibility();
	}

	private updateVisibility() {
		this.visible = this.newVersionAvailable && !this.dismissedAt;
	}
}
